import { NavLink, useLocation } from 'react-router-dom';
import type { User } from '../../types';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const farmerTabs: NavItem[] = [
  { path: '/nong-ho/tong-quan', label: 'Tổng quan', icon: 'ri-dashboard-line' },
  { path: '/nong-ho/nhat-ky', label: 'Nhật ký', icon: 'ri-file-list-line' },
  { path: '/nong-ho/vay-von', label: 'Khoản vay', icon: 'ri-hand-coin-line' },
  { path: '/nong-ho/han-muc', label: 'Hạn mức', icon: 'ri-scales-3-line' },
  { path: '/nong-ho/vat-tu', label: 'Vật tư', icon: 'ri-seedling-line' },
];

const htxTabs: NavItem[] = [
  { path: '/htx/tong-quan', label: 'Tổng quan', icon: 'ri-dashboard-line' },
  { path: '/htx/nong-ho', label: 'Nông hộ', icon: 'ri-team-line' },
  { path: '/htx/hop-dong', label: 'Hợp đồng', icon: 'ri-draft-line' },
  { path: '/htx/vay-han-muc', label: 'Vay & Hạn mức', icon: 'ri-scales-3-line' },
  { path: '/htx/tai-chinh', label: 'Tài chính', icon: 'ri-money-dollar-circle-line' },
];

interface BottomNavProps {
  user: User;
}

export function BottomNav({ user }: BottomNavProps) {
  const location = useLocation();
  const tabs = user.role === 'Nông hộ' ? farmerTabs : htxTabs;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-slate-200/70 z-50 safe-bottom shadow-[0_-8px_24px_rgba(15,23,42,0.06)]">
      <div className="flex items-stretch justify-around max-w-[430px] mx-auto px-1">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={`relative flex flex-col items-center justify-center min-w-0 flex-1 px-0.5 py-2 transition-colors ${
                isActive ? 'text-agrida-600' : 'text-gray-400'
              }`}
            >
              <span className="w-7 h-7 flex items-center justify-center">
                <i className={`${tab.icon} text-[22px]`} />
              </span>
              <span className="text-[9px] sm:text-[10px] mt-0.5 font-semibold text-center leading-tight line-clamp-2 min-h-[20px] flex items-center">
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
